import { render, staticRenderFns } from "./CbrUpdatesList.vue?vue&type=template&id=366637ba&scoped=true&lang=pug&"
import script from "./CbrUpdatesList.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesList.vue?vue&type=script&lang=js&"
import style0 from "./CbrUpdatesList.vue?vue&type=style&index=0&id=366637ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366637ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
